export const CREATE_PAYMENT_LINK = "CREATE_PAYMENT_LINK";
export const CREATE_PAYMENT_LINK_SUCCESS = "CREATE_PAYMENT_LINK_SUCCESS";
export const CREATE_PAYMENT_LINK_FAIL = "CREATE_PAYMENT_LINK_FAIL";

export const CHECK_PAYMENT_STATUS = "CHECK_PAYMENT_STATUS";
export const CHECK_PAYMENT_STATUS_SUCCESS = "CHECK_PAYMENT_STATUS_SUCCESS";
export const CHECK_PAYMENT_STATUS_FAIL = "CHECK_PAYMENT_STATUS_FAIL";

export const GET_EXTERNAL_USERS_COUNT = "GET_EXTERNAL_USERS_COUNT";
export const GET_EXTERNAL_USERS_COUNT_SUCCESS = "GET_EXTERNAL_USERS_COUNT_SUCCESS";
export const GET_EXTERNAL_USERS_COUNT_FAIL = "GET_EXTERNAL_USERS_COUNT_FAIL";
